define((require) => {
    "use strict";

    var EasingTypes                 = require("shared/ui/experience/widgets/animations/EasingTypes"),
        ImprovedView                = require("editor/zbone/ImprovedView"),
        MoveAnimationRepresentation = require("ui/experience/widgets/animations/move/MoveAnimationRepresentation"),
        Preconditions               = require("shared/util/Preconditions"),
        template                    = require("ui/experience/widgets/animations/move/MoveAnimationPropertiesView.tpl");

    var LEFT_ARROW = "&larr;",
        RIGHT_ARROW = "&rarr;",
        UPWARD_ARROW = "&uarr;",
        DOWNWARD_ARROW = "&darr;";

    /**
     * The properties view for a move animation.
     *
     * @class MoveAnimationPropertiesView
     *
     * @cfg {MoveAnimationModel} model The Move animation model being edited.
     */
    return ImprovedView.extend({

        template: template,

        _representation: null,

        bindings: {
            "#move-easing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#direction": "direction",
            "#delay": {
                observe: "delay",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            },
            "#animation-move-horizontal": {
                observe: "horizontalMove",
                onGet: "onGet",
                onSet: "onSet"
            },
            "#animation-move-vertical": {
                observe: "verticalMove",
                onGet: "onGet",
                onSet: "onSet"
            }
        },

        templateHelpers: function() {
            var horizontalMoveValue = this.model.get("horizontalMove"),
                verticalMoveValue = this.model.get("verticalMove");

            return {
                horizontalMoveUnescaped: horizontalMoveValue < 0 ? LEFT_ARROW : RIGHT_ARROW,
                verticalMoveUnescaped: verticalMoveValue < 0 ? UPWARD_ARROW : DOWNWARD_ARROW
            };
        },

        ui: {
            horizontalInput: "#animation-move-horizontal",
            verticalInput: "#animation-move-vertical",
            horizontalArrow: "#animation-move-horizontal-arrow",
            verticalArrow: "#animation-move-vertical-arrow"
        },

        events: {
            "focus #animation-move-horizontal": function() {
                this._representation.addRepresentationToDom();
            },
            "focus #animation-move-vertical": function() {
                this._representation.addRepresentationToDom();
            },
            "blur #animation-move-horizontal": function() {
                this._representation.removeRepresentationToDom();
            },
            "blur #animation-move-vertical": function() {
                this._representation.removeRepresentationToDom();
            },
            "click #animation-move-horizontal-arrow": "_changeArrowDirection",
            "click #animation-move-vertical-arrow": "_changeArrowDirection"
        },

        initialize: function() {
            var widgetModel = this.options.widgetModel,
                animationModel = this.model;

            function updatePositionFromModel() {
                animationModel.set({
                    fromTop: widgetModel.get("top"),
                    fromLeft: widgetModel.get("left")
                });
            }

            this.listenTo(widgetModel, "change:top change:left", updatePositionFromModel);

            // Perform initial update
            updatePositionFromModel();
        },

        _changeArrowDirection: function(event) {
            var arrow = event.target,
                attribute = arrow.getAttribute("data-direction"),
                value = -this.model.get(attribute);

            this.model.set(attribute, value);

            switch (attribute) {
                case "verticalMove":
                    arrow.innerHTML = value < 0 ? UPWARD_ARROW : DOWNWARD_ARROW;
                    break;
                case "horizontalMove":
                    arrow.innerHTML = value < 0 ? LEFT_ARROW : RIGHT_ARROW;
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Attribute '" + attribute + "' not recognized.");
                    break;
            }
        },

        onGet: function(value, options) {
            var experienceModel = this.viewScope.viewModel.get("experience"),
                pixelPosition = experienceModel.getPixelPosition({left: value, top: value});

            switch (options.observe) {
                case "horizontalMove":
                    return Math.abs(Math.round(pixelPosition.left));
                case "verticalMove":
                    return Math.abs(Math.round(pixelPosition.top));
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Move '" + options.observe + "' not recognized.");
                    break;
            }
        },

        // don't use rounding here, otherwise the value will lost precision onGet.
        onSet: function(value, options) {
            var experienceModel = this.viewScope.viewModel.get("experience"),
                percentagePosition = experienceModel.getPercentagePosition({
                    left: Math.abs(value),
                    top: Math.abs(value)
                }),
                oldValue = this.model.get(options.observe);

            switch (options.observe) {
                case "horizontalMove":
                    return oldValue >= 0 ? percentagePosition.left : -percentagePosition.left;
                case "verticalMove":
                    return oldValue >= 0 ? percentagePosition.top : -percentagePosition.top;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Move '" + options.observe + "' not recognized.");
                    break;
            }
        },

        onRender: function() {
            var experience = this.viewScope.viewModel.get("experience");
            this._representation = new MoveAnimationRepresentation(experience, this.options.widgetView, this.model);
            this.listenTo(this.model, "change:horizontalMove change:verticalMove", this._representation.moveRepresentation.bind(this._representation));
        },

        onClose: function() {
            this._representation.removeRepresentationToDom.call(this._representation);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/move/MoveAnimationPropertiesView.js